import isEmpty from "lodash/isEmpty"
import get from "lodash/get"
import map from "lodash/map"
import toNumber from "lodash/toNumber"
import getLanguageRoute from "utils-lib/getLanguageRoute"
import { AuthoringUtils } from "@adobe/aem-spa-page-model-manager"
import { connect } from "react-redux"
import {
  getCombinedProductsUrl,
  getCartDetails,
  setCustomerLob,
  setUserState,
  makeMinorAlertVisible,
  setIsCustomerSelectClicked,
  setNewMultiAccountTabSelected,
} from "actions-lib"
import { setMenuOpen } from "actions-lib/setMenuOpen"
import {
  getNotificationsByAddress,
  getNotificationsByUserId,
} from "actions-lib/getNotifications"
import { getGlobalAlerts } from "actions-lib/getGlobalAlerts"
import { getIncidentsByUserId } from "actions-lib/getIncidents"
import { setShowMobileSearch } from "actions-lib/setShowMobileSearch"
import { isBrokerAccountSelector } from "selectors-lib/linkedAccounts"
import Header from "./Header"

const ALERT_TYPE_MAPPING = {
  "Major Alert": "majorAlerts",
  "Minor Alert": "minorAlerts",
  "Privacy Alert": "privacyAlerts",
  "Modal Alert": "browserAlerts",
}

const mapDispatchToProps = {
  getCartDetails,
  getCombinedProductsUrl,
  getGlobalAlerts,
  getIncidentsByUserId,
  getNotificationsByAddress,
  getNotificationsByUserId,
  setCustomerLob,
  setMenuOpen,
  setUserState,
  setShowMobileSearch,
  makeMinorAlertVisible,
  setIsCustomerSelectClicked,
  setNewMultiAccountTabSelected,
}

function getMappedGlobalAlerts(alerts) {
  return map(alerts, (item) => ({
    alertType: ALERT_TYPE_MAPPING[item.globalAlertType],
    title: item.heading,
    subtext: item.description,
    linktext: item.hyperLinkTitle,
    href: item.hyperLinkUrl,
    iconClose: "/content/dam/wm/icons/white-close-x-icon.svg",
    stateList: item.stateList ? item.stateList : ``,
  }))
}

let mapStateToProps = (state) => ({
  alert: state.alert,
  languageRoute: getLanguageRoute(get(state, `siteLanguage.language`, `en_CA`)),
  ecommerceCart: state.ecommerceCart,
})

if (!AuthoringUtils.isInEditor()) {
  mapStateToProps = (state, props) => {
    // we're going to try to get the SSR model first, then default to redux state
    const aemDataObject = !isEmpty(props.dataPageData)
      ? props.dataPageData
      : state.aemData

    return {
      alert: state.alert,
      isSingleAccount:
        get(state.userManageAccount, `linkedAccounts.length`, 0) === 1,
      languageRoute: getLanguageRoute(
        get(state, `siteLanguage.language`, `en_CA`),
      ),
      navigationDetails: get(
        aemDataObject,
        `standardnavigation.navigationDetails`,
        [],
      ),
      alerts: getMappedGlobalAlerts(
        get(state.notifications, `globalAlerts`, []),
      ),
      logo: get(aemDataObject, `standardnavigation.logo`, ``),
      logoAltText: get(aemDataObject, `standardnavigation.logoAltText`, ``),
      logoLink: get(aemDataObject, `standardnavigation.logoLink`, ``),
      utilityBarLinks: get(
        aemDataObject,
        `standardnavigation.utilityBarLinks`,
        [],
      ),
      loginDropdownLabel: get(
        aemDataObject,
        `standardnavigation.loginDropdownLabel`,
        ``,
      ),
      loginEmailPlaceholderText: get(
        aemDataObject,
        `standardnavigation.loginEmailPlaceholderText`,
        ``,
      ),
      loginPasswordPlaceholderText: get(
        aemDataObject,
        `standardnavigation.loginPasswordPlaceholderText`,
        ``,
      ),
      loginButtonCta: get(
        aemDataObject,
        `standardnavigation.loginButtonCta`,
        ``,
      ),
      forgotEmailPwText: get(
        aemDataObject,
        `standardnavigation.forgotEmailPwText`,
        ``,
      ),
      continueAsGuestText: get(
        aemDataObject,
        `standardnavigation.continueAsGuestText`,
        ``,
      ),
      createProfileText: get(
        aemDataObject,
        `standardnavigation.createProfileText`,
        ``,
      ),
      myWmDropdownLabel: get(
        aemDataObject,
        `standardnavigation.myWmDropdownLabel`,
        ``,
      ),
      myWmMenuHeading: get(
        aemDataObject,
        `standardnavigation.myWmMenuHeading`,
        ``,
      ),
      logoutCtaText: get(aemDataObject, `standardnavigation.logoutCtaText`, ``),
      simplenavigation: get(aemDataObject, `simplenavigation`, {}),
      customerLob: get(state.customerSelections, `customerLob`),
      ecommerceCart: state.ecommerceCart,
      copyright: get(aemDataObject, `footer.copyrightMessaging`, ``),
      legalLinks: get(aemDataObject, `footer.legalLinks`, []),
      siteLanguage: state.siteLanguage,
      userProducts: get(state.customerSelections, `userProducts`, {}),
      userState: get(state.userAccount, `userState`, ``),
      userAddress: get(state.userAccount, `userAddress`, {}),
      alertsRead: get(state, `customerSelections.alertsRead`, false),
      customerAddress: get(state, `customerSelections.customerAddress`, {}),
      isAddressSearch: get(state, `customerSelections.isAddressSearch`, true),
      userId: get(state, `userAccount.userDetails.userId`, ``),
      firstName: get(state, `userAccount.userDetails.firstName`, ``),
      emailId: get(state, `userAccount.userDetails.login`, ``),
      mobilePhone:
        get(state, `userAccount.userDetails.mobilePhone`) ??
        get(state, `userAccount.userDetails.primaryPhone`) ??
        ``,
      selectedAccountDetails: get(
        state,
        `multiAccountDashboard.selectedAccountDetails`,
        {},
      ),
      notificationsFetchState: get(state, `notifications.fetchState`, ``),
      notifications: get(state, `notifications.notifications`, []),
      facilityLocator: state.facilityLocator,
      incidents: get(state, `notifications.incidents`, []),
      notificationsLanguage: get(
        state,
        `notifications.notificationsLanguage`,
        ``,
      ),
      getCombinedProductUrlStatus: get(
        state.customerSelections,
        `getCombinedProductUrlStatus`,
        ``,
      ),
      combinedProductSupportData: get(
        state.customerSelections,
        `combinedProductSupportData`,
        {},
      ),
      selectedLob: get(state.customerSelections, `selectedLob`, ``),
      showMobileSearch: get(
        state.customerSelections,
        `showMobileSearch`,
        false,
      ),
      isSupportSearch: get(state.customerSelections, `isSupportSearch`, false),
      indexList: get(aemDataObject, `standardnavigation.indexList`, []),
      resultsIndex: get(
        aemDataObject,
        `standardnavigation.siteSearchIndex`,
        "wmSite_us_en",
      ),
      queryIndex: get(
        aemDataObject,
        `standardnavigation.queryIndex`,
        `crawler_algolia_features`,
      ),
      filterType: get(
        aemDataObject,
        `standardnavigation.filterType`,
        // "wmSite_us_en",
        "algolia:suggested",
      ),
      searchBarPlaceholderText: get(
        aemDataObject,
        `standardnavigation.searchBarPlaceholderText`,
        `How can we help?`,
      ),
      numResults: toNumber(
        get(aemDataObject, `standardnavigation.numberOfResults`, 10),
      ),
      numHighlightedResults: toNumber(
        get(aemDataObject, `standardnavigation.numberOfHighlightedResults`, 3),
      ),
      numberQueries: toNumber(
        get(aemDataObject, `standardnavigation.numberOfQueries`, 2),
      ),
      numCharacters: toNumber(
        get(aemDataObject, `standardnavigation.numberOfCharacters`, 3),
      ),
      errorMessageTitle: get(
        aemDataObject,
        `standardnavigation.errorMessageTitle`,
        `Error`,
      ),
      errorMessageDescription: get(
        aemDataObject,
        `standardnavigation.errorMessageDescription`,
        `Can't find...`,
      ),
      failureTitle: get(
        aemDataObject,
        `standardnavigation.failureTitle`,
        `Failure`,
      ),
      failureDescription: get(
        aemDataObject,
        `standardnavigation.failureDescription`,
        `Failed...`,
      ),
      suggestedText: get(
        aemDataObject,
        `standardnavigation.suggestedText`,
        `Suggested`,
      ),
      resultsText: get(
        aemDataObject,
        `standardnavigation.resultsText`,
        `Results`,
      ),
      seeAllResultsText: get(
        aemDataObject,
        `standardnavigation.seeAllResultsText`,
        `SEE ALL RESULTS`,
      ),
      searchDelay: toNumber(
        get(aemDataObject, `standardnavigation.searchDelay`, 350),
      ),
      localsitesCdn: state.localsitesCdn,
      multiAccountDashboard: state.multiAccountDashboard,
      isBrokerAccount: isBrokerAccountSelector(state),
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Header)
